import React from 'react';
import Slider from 'react-slick';
import SliderItem from '../components/SliderItem';

const HomeSlider02 = () => {
    const SliderData = [
        {
            id: '1',
            bg: 'images/slider/4.jpg',
            text: 'Exotic and Delicious',
        },
        {
            id: '2',
            bg: 'images/slider/5.jpg',
            text: 'Exotic and Delicious',
        },
        {
            id: '3',
            bg: 'images/slider/6.jpg',
            text: 'Exotic and Delicious',
        },
    ];

    const settings = {
        infinite: false,
        speed: 500,
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        vertical: true,
        verticalSwiping: true,
    };

    return (
        <div className="theme_slider_2">
            <div className="slider_slick">
                <Slider {...settings}>
                    {
                        SliderData.map(data => <SliderItem
                            key={data.id}
                            data={data}
                        />)
                    }
                </Slider>
            </div>
        </div>
    );
};

export default HomeSlider02;